"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgEndpoint = void 0;
var MsgEndpoint;
(function (MsgEndpoint) {
    MsgEndpoint["MSG_SEND"] = "/bank.MsgSend";
    MsgEndpoint["MSG_ADD_PKG"] = "/vm.m_addpkg";
    MsgEndpoint["MSG_CALL"] = "/vm.m_call";
})(MsgEndpoint || (exports.MsgEndpoint = MsgEndpoint = {}));
